import { render, staticRenderFns } from "./donation-statistics.vue?vue&type=template&id=52659b40"
import script from "./donation-statistics.vue?vue&type=script&lang=js"
export * from "./donation-statistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports